// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"utilityComponents_Paragraph__1N7R1","Headline":"utilityComponents_Headline__3cakX"};